import type { JSX } from "react";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useABTestingEffect } from "./ab-testing";
import { useAuthenticationAnalyticsBridgeEffect } from "./authentication-analytics-bridge";
import { useBoardEventAnalyticsBridgeEffect } from "./board-event-analytics-bridge";
import { useMigrateBoardsEffect } from "./board-state";
import { useMigrateTeamsEffect } from "./custom-player";
import {
  useMigrateFormationsEffect,
  usePromptShareFormationEffect,
} from "./formation";
import { usePreferencesEffect } from "./preferences";
import { usePromptPreferencesEffect } from "./prompt-preferences";
import { usePromptSignInEffect } from "./prompt-sign-in";
import { useBoardTypeSyncEffect } from "./select-board-type";
import { useUserEffect } from "./user";

export function ApplicationsEffects(): JSX.Element {
  const components = effectHooks.map((effectHook, index) => (
    <ErrorBoundary key={index} fallback={<></>}>
      <Suspense>
        <HookComponent useHook={effectHook} />
      </Suspense>
    </ErrorBoundary>
  ));

  return <>{components}</>;
}

const effectHooks = [
  useABTestingEffect,
  usePreferencesEffect,
  useBoardTypeSyncEffect,
  useMigrateBoardsEffect,
  useMigrateFormationsEffect,
  useMigrateTeamsEffect,
  useBoardEventAnalyticsBridgeEffect,
  useAuthenticationAnalyticsBridgeEffect,
  usePromptSignInEffect,
  usePromptPreferencesEffect,
  usePromptShareFormationEffect,
  useUserEffect,
];

function HookComponent(props: { useHook: () => void }): JSX.Element {
  const { useHook } = props;
  useHook();
  return <></>;
}
